"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("core/utils");
var $injector = null;
/**
 * @class
 * @name ProviderService
 * @description Returns a singleton that is used to access the Angular
 * application's injector. In order for this service to work, the application
 * must register the $injector (ideally via a .run clause) after loading.
 */
exports.default = new /** @class */ (function () {
    function ProviderService() {
    }
    /**
     * @name ProviderService#register
     * @param {Object} injector The Angular $injector
     * @description Register an injector
     */
    ProviderService.prototype.register = function (injector) {
        $injector = injector;
    };
    /**
     * @name ProviderService#get
     * @param {string} name The name of the service to retrieve from the $injector.
     * @description Gets the given service from the injector. If a mock has been set
     * up for it, it returns that instead.
     */
    ProviderService.prototype.get = function (name) {
        if ($injector === null) {
            throw new Error('ng: $injector not registered for core/services/ng');
        }
        return $injector.get(name);
    };
    ProviderService.prototype.waitForServicesToBeAvailable = function () {
        return utils_1.waitUntil(function () { return $injector != null; });
    };
    ProviderService.prototype.getService = function (name) {
        return this.getServices([name]).then(function (res) { return res[0]; });
    };
    ProviderService.prototype.getServices = function (names) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.waitForServicesToBeAvailable()
                .then(function () {
                resolve(names.map(function (name) { return $injector.get(name); }));
            });
        });
    };
    return ProviderService;
}())();



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/ng.ts
// module id = 444
// module chunks = 0